/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `course_point` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class CoursePointMesg : Mesg {
    public constructor() : super("CoursePoint", Profile.MesgNum.COURSE_POINT)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** position_lat, in semicircles. */
    public var positionLat: Int?
        get() = getFieldValue(POSITION_LAT_FIELD_NUM) as? Int
        set(value) = setFieldValue(POSITION_LAT_FIELD_NUM, value)

    /** position_long, in semicircles. */
    public var positionLong: Int?
        get() = getFieldValue(POSITION_LONG_FIELD_NUM) as? Int
        set(value) = setFieldValue(POSITION_LONG_FIELD_NUM, value)

    /** distance, in m. */
    public var distance: Double?
        get() = getFieldValue(DISTANCE_FIELD_NUM) as? Double
        set(value) = setFieldValue(DISTANCE_FIELD_NUM, value)

    /** type. */
    public var type: CoursePoint?
        get() = (getFieldValue(TYPE_FIELD_NUM) as? UByte)?.let { CoursePoint.fromValue(it) }
        set(value) = setFieldValue(TYPE_FIELD_NUM, value?.value)

    /** name. */
    public var name: String?
        get() = getFieldValue(NAME_FIELD_NUM) as? String
        set(value) = setFieldValue(NAME_FIELD_NUM, value)

    /** favorite. */
    public var favorite: Boolean?
        get() = (getFieldValue(FAVORITE_FIELD_NUM) as? UByte)?.let { it.toInt() != 0 }
        set(value) = setFieldValue(FAVORITE_FIELD_NUM, value?.let { if (it) 1 else 0 })

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val TIMESTAMP_FIELD_NUM: UByte = 1u
        public const val POSITION_LAT_FIELD_NUM: UByte = 2u
        public const val POSITION_LONG_FIELD_NUM: UByte = 3u
        public const val DISTANCE_FIELD_NUM: UByte = 4u
        public const val TYPE_FIELD_NUM: UByte = 5u
        public const val NAME_FIELD_NUM: UByte = 6u
        public const val FAVORITE_FIELD_NUM: UByte = 8u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[1] = Field("Timestamp", 1u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[2] = Field("PositionLat", 2u, BaseType.SINT32, 1.0, 0.0, "semicircles", false)
            fields[3] = Field("PositionLong", 3u, BaseType.SINT32, 1.0, 0.0, "semicircles", false)
            fields[4] = Field("Distance", 4u, BaseType.UINT32, 100.0, 0.0, "m", false)
            fields[5] = Field("Type", 5u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[6] = Field("Name", 6u, BaseType.STRING, 1.0, 0.0, "", false)
            fields[8] = Field("Favorite", 8u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
